export default "__VITE_ASSET__59ca3d82__"